/**
 * 공개 목록용 닉네임. 앞 두 글자, 별 세 개, 끝 세 글자. 화면에는 최대 8자.
 * 짧은 이름은 앞과 끝이 겹치지 않게 자르고, 빈자리는 별로 채운다.
 */
export function maskNickname(name) {
  const chars = Array.from(String(name ?? '').trim());
  const length = chars.length;
  if (length === 0) return '';
  if (length === 1) return `${chars[0]}*`;
  if (length === 2) return `${chars[0]}*${chars[1]}`;
  const tail = chars.slice(Math.max(2, length - 3)).join('');
  return chars.slice(0, 2).join('') + '***' + tail;
}
